import PropTypes from "prop-types";
import GroupPropType from "./group";

const personFields = {
  address: PropTypes.string,
  city: PropTypes.string,
  avatar: PropTypes.string,
  company: PropTypes.string,
  email: PropTypes.string,
  employeeId: PropTypes.string,
  externalId: PropTypes.string,
  firstName: PropTypes.string,
  surname: PropTypes.string,
  preferredName: PropTypes.string,
  fte: PropTypes.number,
  gender: PropTypes.string,
  jobTitle: PropTypes.string,
  mobileNumber: PropTypes.string,
  telephoneNumber: PropTypes.string,
  createdAt: PropTypes.string,
  division: GroupPropType,
  __typename: PropTypes.string,
};

const BasePersonPropType = PropTypes.shape({
  ...personFields,
  aggregateId: PropTypes.string.isRequired,
  managedByHierarchy: PropTypes.array,
  managing: PropTypes.array,
});

const PersonPropType = PropTypes.shape({
  ...personFields,
  aggregateId: PropTypes.string.isRequired,
  managedByHierarchy: PropTypes.arrayOf(BasePersonPropType),
  managing: PropTypes.arrayOf(BasePersonPropType),
});

// Node card data can be a loading placeholder (e.g. { name, isLoading: true })
// that has no aggregateId yet, so the identifier is optional here.
export const PersonNodeDataPropType = PropTypes.shape({
  ...personFields,
  aggregateId: PropTypes.string,
  isLoading: PropTypes.bool,
  managedByHierarchy: PropTypes.arrayOf(BasePersonPropType),
  managing: PropTypes.arrayOf(BasePersonPropType),
});

export default PersonPropType;
